export default function Highlight3({ subtitle, topTitle, text, reverse }) {
  return (
    <section>
      <div className="my-4 flex justify-center font-['Inter']" tabIndex={0}>
        <div
          className={`${
            reverse
              ? "w-full xl:max-w-7xl lg:max-w-4xl md:max-w-3xl flex flex-col items-center lgjustify-between lg:flex-row-reverse "
              : "w-full xl:max-w-7xl lg:max-w-4xl md:max-w-3xl flex flex-col items-center lg:justify-between lg:flex-row "
          }`}
        >
          <div className="lg:w-1/2 px-16 pt-16 lg:p-16">
            <p className="text-orange-400 font-bold mb-1 lg:mt-0 mt-4">
            WHAT IS CKAN
            </p>
            <h3 className="medium-title">
            Your complete data management solution
            </h3>
          </div>
          <div className="lg:w-1/2 px-16 py-16 lg:p-16">
            <p className="text-secgray text-lg"><a className="text-maingray underline" href="https://ckan.org" target="_blank">CKAN</a> makes it easy to publish, share and work with data and metadata. It&apos;s a data management system that provides a powerful platform for cataloging, storing and accessing datasets with a rich front-end, full API (for both data and catalog), visualization tools and more.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
